module.exports = __webpack_public_path__ + "static/ddrc-9547fd66379b0ab6b77f6fde8667b397.png";